import React from "react";

function Footer() {
  return (
    <div className="foot fl">
      <div className="foot-left">
        <p>
          College of Computer Science and Technology, Zhejiang University of
          Technology
          <br />
          Hangzhou 310023, China
          <br />
          ©Group of City Science &amp; Social Computing
          <br />
          Email:&nbsp;NingLi68@outlook.com
        </p>
        <p style={{ fontStyle: "italic" }}>Design By: Ning Li & Bing Zhu</p>
      </div>
    </div>
  );
}

export { Footer };
